var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{attrs:{"id":"example-1"}},_vm._l((_vm.urlImagenes),function(item){return _c('li',[_c('span',[_vm._v(" "+_vm._s(item.title))]),_c('b-img',{attrs:{"src":item.url,"fluid":"","alt":"Imagen vacia"}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }